import { PaymentMethodEnum } from 'common/enums/PaymentMethodEnum'
import {
  ProductInterface,
  ProductVariantInterface,
} from 'common/types/entities/ProductInterface'
import { PricePlan } from 'common/types/OfferInterface'
import { calculatePrice } from 'src/publisher/api/calculate-price'
import {
  CalculatePriceRequest,
  CalculatePriceResponse,
  OfferCustomer,
} from 'src/shared/types/pricing-types'

export interface GetOfferPricing {
  product: ProductInterface | null
  productBump?: ProductInterface | null
  pricePlans: PricePlan[]
  bumpPlan?: PricePlan
  bumpOfferId?: number
  offerId: number
  productQuantity: number
  activeProductVariant: ProductVariantInterface | null
  country?: string
  couponCode?: string
  taxNumber?: string
  paymentMethod?: PaymentMethodEnum | null
  shippingRule?: number
  shippingCondition?: number

  abortSignal?: AbortSignal
}

export const calculateOfferPricing = async ({
  product,
  productBump,
  pricePlans,
  bumpPlan,
  bumpOfferId,
  offerId,
  productQuantity,
  activeProductVariant,
  country,
  couponCode,
  taxNumber,
  paymentMethod,
  shippingRule,
  shippingCondition,

  abortSignal,
}: GetOfferPricing): Promise<CalculatePriceResponse[]> => {
  if (!offerId || (!product?.id && !pricePlans.length)) {
    return []
  }

  const customer: OfferCustomer = {
    countryCode: country ?? null,
    taxNumber,
    paymentMethod,
  }

  const offers: CalculatePriceRequest[] = pricePlans.map(pricePlan => ({
    customer,
    quantity: 1,
    offer: offerId,
    couponCode,
    pricePlan: pricePlan.id,
  }))

  if (bumpPlan && bumpOfferId) {
    offers.push({
      customer,
      quantity: 1,
      offer: bumpOfferId,
      pricePlan: bumpPlan.id,
      // bumps are a special case with coupon not being applicable
      couponCode: undefined,
    })
  }

  if (product?.id) {
    offers.push({
      customer,
      product: product?.id,
      pricePlan: activeProductVariant?.pricePlan.id ?? product.pricePlan.id,
      quantity: productQuantity,
      offer: offerId,
      couponCode,
      shippingRule,
      shippingCondition,
    })
  }

  if (productBump?.id && bumpOfferId) {
    offers.push({
      customer,
      product: productBump?.id,
      pricePlan: productBump.pricePlan.id,
      quantity: 1,
      offer: bumpOfferId,
      // bumps are a special case with coupon not being applicable
      couponCode: undefined,
    })
  }

  const { data } = await calculatePrice(offers, abortSignal)

  return data
}
